import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CommoditiesCreateFormFields } from "web_myplann/Portfolio/Forms/CommoditiesForm/CommoditiesCreateFormFields";
import { useCreateCommoditiesForm } from "web_myplann/Portfolio/Forms/CommoditiesForm/useCreateCommoditiesForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreateCommoditiesForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateCommoditiesForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<CommoditiesCreateFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
